import { connect } from 'react-redux';
import { Thunk } from 'ha/myredux/types';
import { DispatchProps, ShareButtons } from '../components/ShareButtons';

const initFB: () => Thunk =
  () =>
  (_, __, { facebook }) =>
    facebook.init();

const mapDispatchToProps: DispatchProps = {
  initFB,
};

const ShareButtonsContainer = connect(null, mapDispatchToProps)(ShareButtons);
export { ShareButtonsContainer };
